import type { BoxRef } from "../../../../../../mads";

import { useCallback } from "react";
import { Share } from "react-native";

export interface ShareModel {
  message: string;
  url: string;
}

export function useShareJob() {
  return useCallback(async (shareModel: ShareModel, returnFocusElement?: BoxRef | null) => {
    returnFocusElement?.focus?.();
    return await Share.share({
      message: `${shareModel.message}\n${shareModel.url}`,
      url: shareModel.url,
    });
  }, []);
}
